export default "__VITE_ASSET__C9$$s1lH__"